$(document).ready(function (e) {
    if ($(".js-registerContinue-page").length === 0) {
        return;
    }

    // 郵便番号検索ボタン
    $(".js-post-code").unbind();
    $(".js-post-code").click(function () {
        const postCodeValue = $("#postCode").val();
        postCode.postCodeToAddress(postCodeValue);
    });

    // 都道府県情報の変更のドロップダウン構成
    $("[name=prefectureCode]").unbind();
    $("[name=prefectureCode]").change(function () {
        postCode.changePrefectureDropDownList();
    });
});
